import React,{useState,useEffect} from 'react';
import { Router, Location, Redirect,useParams } from 'react-router-dom';
import LogoX from './../../assets/icons/logo.png';
import Waiter from './../../assets/gif/blueCircle.gif';
import AssetIcon from "./../../assets/icons/thumbnail@2x.png";
import { createGlobalStyle } from 'styled-components';
import { DOCUMENT_LIST } from './../../prefixed/documents';
import $ from 'jquery';
import axios from 'axios';
import {validateInput as _vli,validateAllUIInputs as _vlai,stringToHex} from "./validator";
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from './../../constants';
import Resizer from "react-image-file-resizer";
let assetInfo={
	inUse:"No",
	je:"",
	ae:"",
	ee:"",
	implementAgency:"",
	fundingAgency:"",
	userAgency:"",
	assetType:"",
	assetName:"",
	assetDescription:"",
	address:"",
	village:"",
	panchayat:"",
	pin:"",
	block:"",
	district:"Ramgarh",
	state:"Jharkhand",
	country:"INDIA",
	beneficiary:""
};
let assetDetail={
	agrCost:"",
	agrDate:"",
	estCost:"",
	estWorkStartDate:"",
	estWorkCompleteByDays:"",
	workStartDate:"",
	workFinishDate:"",
	workStatus:"",
	workProgress:"",
	lat:"0.0",
	lng:"0.0",
	maintenanceDays:"0",
	photos:""
};
let contractorInfo={
	regNo:"",
	name:"",
	companyName:"",
	contactNo:"",
	address:"",
	district:"",
	state:"",
	country:"INDIA"
};
const JComponent= (props) => {
  let urlParam = useParams(); // it extracts pramater from file pth like /page/color/:param
  const [assetInfoData,setAssetInfoData]=useState(assetInfo);
  const [assetDetailData,setAssetDetailData]=useState(assetDetail);
  const [contractorInfoData,setContractorInfoData]=useState(contractorInfo);
  const [assetsCategoryList,setAssetsCategoryList]=useState([]);
  const [engineerList,setEngineerList]=useState([]);
  const [implAgencyList,setImplAgencyList]=useState([]);
  const [fundingAgencyList,setFundingAgencyList]=useState([]);
  const [userAgencyList,setUserAgencyList]=useState([]);
  const [blockList,setBlockList]=useState(null);
  const [panchayatList,setPanchayatList]=useState([]);
  const [newImages,setNewImages]=useState([AssetIcon]);
  const [reqWait,setReqWait]=useState(false);
  const [reqWaitUpload,setReqWaitUpload]=useState(false);
  const [loginedEmail,setLoginedEmail]=useState("");
  const [department,setDepartment]=useState("");
  useEffect(()=>{
	setLoginedEmail(localStorage.getItem("_xoxem"));
	let _department=localStorage.getItem("_xoxdp");
	setDepartment(_department);
	setAssetInfoData((prev)=>{return {...prev,implementAgency:_department}});
	loadEngineerList(_department);
  },[])
  useEffect(()=>{
	  /*setTimeout(()=>{
		window["initCalander"]("estWorkStartDate");
		window["initCalander"]("agrDate");
		window["initCalander"]("workStartDate");
		window["initCalander"]("workFinishDate");
	  },2000);*/
  },[]);
  useEffect(()=>{
	 if(JSON.stringify(assetInfo) !== JSON.stringify(assetInfoData)){
		localStorage.setItem("p.x",JSON.stringify(assetInfoData));
	 }
  },[assetInfoData]);
  useEffect(()=>{
	 if(JSON.stringify(assetDetail) !== JSON.stringify(assetDetailData)){
		localStorage.setItem("p.u",JSON.stringify(assetDetailData));
	 }
  },[assetDetailData]);
  useEffect(()=>{
	 if(JSON.stringify(contractorInfo) !== JSON.stringify(contractorInfoData)){
		localStorage.setItem("p.c",JSON.stringify(contractorInfoData));
	 }
  },[contractorInfoData]);
  useEffect(()=>{
	let tmp_pd=localStorage.getItem("p.x");
	let tmp_un=localStorage.getItem("p.u");
	let tmp_cd=localStorage.getItem("p.c");
	if(tmp_pd) setAssetInfoData(JSON.parse(tmp_pd));
	if(tmp_un) setAssetDetailData(JSON.parse(tmp_un));
	if(tmp_cd) setContractorInfoData(JSON.parse(tmp_cd));
	if(urlParam.name) setContractorInfoData((prev)=>{return {...prev,stream:urlParam.name}});
  },[]);
  useEffect(()=>{
	loadBlockList();
	loadAssetCategoryList();
	loadImplAgencyList();
	loadFundingAgencyList();
	loadUserAgencyList();
	
	
  },[])
  const manageDatesUI=()=>{
	assetDetailData.estWorkStartDate=$("#estWorkStartDate").val();
	assetDetailData.agrDate=$("#agrDate").val();
	assetDetailData.workStartDate=$("#workStartDate").val();
	assetDetailData.workFinishDate=$("#workFinishDate").val();

  }
  const loadEngineerList=(_deptid)=>{
	var config = {
		method: 'post',
		url: API_CORE_SERVER+"/api/get_engineer_list.php?deptid="+_deptid,
		headers: { 
			//'Content-Type': 'application/x-www-form-urlencoded',
			'Content-Type': 'application/json', 
		},
	    };
	axios(config)
		.then((response)=>{
			if(response.status===200 && response.data){
				setEngineerList(response.data);
			}
			
		}).catch((response)=>{
			console.log(response);
		})
  }
  const loadAssetList=()=>{
	var config = {
		method: 'post',
		url: API_CORE_SERVER+"/api/document/get-documents.php",
		headers: { 
			//'Content-Type': 'application/x-www-form-urlencoded',
			'Content-Type': 'application/json', 
		},
		data:{name:'hellominni'}
	  };
	axios(config)
		.then((response)=>{
			if(response.status===200 && response.data){
				let data=response.data;
				if(data.status===1 && data.data && data.data.length>0){
					let records=data.data;
					for(let i=0;i<records.length;i++){
					  let assetId=records[i].assetId;
					  let rec=JSON.parse(records[i].data);
					}
				}
				
			}
			
		}).catch((response)=>{
			console.log(response);
		})
  }
  const loadBlockList=()=>{
	var config = {
		method: 'post',
		url: API_CORE_SERVER+"/api/get_block_list.php",
		headers: { 
			//'Content-Type': 'application/x-www-form-urlencoded',
			'Content-Type': 'application/json', 
		},
		data:{name:'hellominni'}
	  };
	axios(config)
		.then((response)=>{
			if(response.status===200 && response.data){
				setBlockList(response.data);
			}
			
		}).catch((response)=>{
			console.log(response);
		})
  }
  const loadAssetCategoryList=()=>{
	var config = {
		method: 'post',
		url: API_CORE_SERVER+"/api/get_asset_category.php",
		headers: { 
			//'Content-Type': 'application/x-www-form-urlencoded',
			'Content-Type': 'application/json', 
		},
		data:{name:'hellominni'}
	  };
	axios(config)
		.then((response)=>{
			if(response.status===200 && response.data){
				setAssetsCategoryList(response.data);
			}
			
		}).catch((response)=>{
			console.log(response);
		})
  }
  const getImplAgencyById=(_id)=>{
	for(let i=0;i<implAgencyList.length;i++){
		if(implAgencyList[i].implAgencyId===_id) return(implAgencyList[i].implAgencyName);
	}
	return(_id);
}
  const loadImplAgencyList=()=>{
	var config = {
		method: 'post',
		url: API_CORE_SERVER+"/api/get_impl_agency.php",
		headers: { 
			//'Content-Type': 'application/x-www-form-urlencoded',
			'Content-Type': 'application/json', 
		},
		data:{name:'hellominni'}
	  };
	axios(config)
		.then((response)=>{
			if(response.status===200 && response.data){
				setImplAgencyList(response.data);
			}
			
		}).catch((response)=>{
			console.log(response);
		})
  }
  const loadFundingAgencyList=()=>{
	var config = {
		method: 'post',
		url: API_CORE_SERVER+"/api/get_funding_agency.php",
		headers: { 
			//'Content-Type': 'application/x-www-form-urlencoded',
			'Content-Type': 'application/json', 
		},
		data:{name:'hellominni'}
	  };
	axios(config)
		.then((response)=>{
			if(response.status===200 && response.data){
				setFundingAgencyList(response.data);
			}
			
		}).catch((response)=>{
			console.log(response);
		})
  }
  const loadUserAgencyList=()=>{
	var config = {
		method: 'post',
		url: API_CORE_SERVER+"/api/get_user_agency.php",
		headers: { 
			//'Content-Type': 'application/x-www-form-urlencoded',
			'Content-Type': 'application/json', 
		},
		data:{name:'hellominni'}
	  };
	axios(config)
		.then((response)=>{
			if(response.status===200 && response.data){
				setUserAgencyList(response.data);
			}
			
		}).catch((response)=>{
			console.log(response);
		})
  }
  const clearForm=()=>{
	setAssetInfoData({
		inUse:"No",
		je:"",
		ae:"",
		ee:"",
		implementAgency:department,
		fundingAgency:"",
		userAgency:"",
		assetType:"",
		assetName:"",
		assetDescription:"",
		address:"",
		village:"",
		panchayat:"",
		pin:"",
		block:"",
		district:"Ramgarh",
		state:"Jharkhand",
		country:"INDIA",
		beneficiary:""}); 
	//document.getElementById("dob").value="";
	
	setAssetDetailData({
	agrCost:"",
	agrDate:"",
	estCost:"",
	estWorkStartDate:"",
	estWorkCompleteByDays:"",
	workStartDate:"",
	workFinishDate:"",
	workStatus:"",	// Ongoing | Completed | Paused
	workProgress:"", // 5 10 15 20.....100
	lat:"0.0",
	lng:"0.0",
	maintenanceDays:"0",
	photos:""});
		
	setContractorInfoData({
	regNo:"",
	name:"",
	companyName:"",
	contactNo:"",
	address:"",
	district:"",
	state:"",
	country:"INDIA"});
	localStorage.setItem("p.x","");	
	localStorage.setItem("p.u","");
	localStorage.setItem("p.c","");
	setNewImages([AssetIcon]);
  }
  const submitForm=()=>{
	//manageDatesUI();
	if(assetDetailData.photos && assetDetailData.photos.length>=10){}
	else {props.modalObject.ok("Please upload photo of asset"); return;}
	props.modalObject.waiting("wait for creating project/assets",true);
	if(assetDetailData.workStatus=="Ongoing"){
		assetDetailData.workFinishDate="0000-00-00";
	}
	let dataset={
		assetInfo:assetInfoData,
		contractorInfo:contractorInfoData,
		assetDetail:assetDetailData,
		creater:loginedEmail
	}
	props.modalObject.waiting("",false);
	//console.log(dataset);
	//console.log("Photos:"+assetDetailData.photos);
	
		//let idata=stringToHex(JSON.stringify(dataset));
	try{
		let idata=JSON.stringify(dataset);
		console.log(idata);
		$.post(API_CORE_SERVER+"/api/document/create.php","i="+idata,async function(result) {
				console.log(result);
				props.modalObject.waiting("",false);
				if(result.status===1){
				clearForm();
				props.modalObject.ok("Successfully Saved");
				} else props.modalObject.ok(result.msg);
		},'json')
		.fail(function(response) {
			props.modalObject.waiting("",false);
			if(response.status===404) props.modalObject.ok("Post URL not found!");
			else props.modalObject.ok("Some critical ui8-issue");
		});
	}catch(e){
		props.modalObject.ok("Kindly check and verify the input data,[ Do not use \", \' and special characters]");
	}
		
	}
	const fileChangedHandler=(event)=>{
		var fileInput = false;
		if (event.target.files[0]) {
		  fileInput = true;
		}
		if (fileInput) {
		  try {
			Resizer.imageFileResizer(
			  event.target.files[0],
			  160,
			  160,
			  "JPEG",
			  100,
			  0,
			  (uri) => {
				
				
				uploadIcon(event,uri);
			  },
			  "base64",
			  96,
			  96
			);
		  } catch (err) {
			console.log(err);
		  }
		}
	}
	const uploadIcon=async(_event,_uri)=>{
		
		try {
			setReqWaitUpload(true);
			let _file=_event.target.files[0];
			//let dataImage=URL.createObjectURL(_event.target.files[0]);
			const formData = new FormData();
        	formData.append('file', _file);
			let response =await axios({
				method: 'post',
				url: API_CORE_SERVER+"/api/upload/image.php",
				headers: { 
					'accept': 'application/json',
					'Content-Type': 'multipart/form-data'
				},
				data : formData 
			});
			if(response.status===200){
				let data=response.data;
				if(data.status===1){
					setNewImages([...newImages, _uri]);
					let _photos=assetDetailData?.photos+","+data.data;
					setAssetDetailData((prev)=>{return {...prev,photos:_photos}});
				}
				else {
					alert(""+data.msg);
				}
			}
			
		  } catch(error) {
			console.log(error)
		  }
		  finally{
			setReqWaitUpload(false);
		  }
		
	}

return(
	<>
	<div className='row'>
					<div className='col-md-8 p-4 rounded-2 mt-4' style={{backgroundColor:'#ffffff'}}>
						<h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-boxes'></i> Project Details</h5>
						<div className="row">
							<div className='col'>
							<div className='d-flex align-items-end'>
								<div className='px-4 '>
									{newImages && newImages.map((newImage,index)=>{
										return(
											<span>
											<img className='p-1' src={newImage}  style={{width:'auto',height:'96px'}}/>
											</span>
										);
									})}
									
								</div>
								<div className='mt-2 text-center position-relative'>
									<input type="file" className='form-control position-absolute' onChange={fileChangedHandler} 
									style={{backgroundColor:'#481886',zIndex:999,top:0,opacity:0}}
									disabled={reqWaitUpload}
									/>
									<button className='btn rounded-pill px-4 -py-4 text-white fw-bold'
									style={{backgroundColor:'#481886'}}
									onClick={e=>{}}
									disabled={reqWaitUpload}
									>
										{reqWaitUpload===true?
												<><img src={Waiter} style={{width:'22px'}} /></>
											:
												<> <i className="bi bi-arrow-up"></i> Upload Photo </>
										}
									</button>
								</div>
								
							</div>		
							</div>
						</div>
						<div  className="row">
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<select type="text" className="form-select jform-control" id="workStatus" value={assetDetailData.workStatus} 
									 placeholder="Enter work status" 
									 onChange={e=>{setAssetDetailData((prev)=>{
											if(e.target.value==="Completed"){
												const date=new Date();
												const dd=date.getDate();
												const mm=date.getMonth()+1;
												const yy=date.getFullYear();
												$("#workFinishDate").val(yy+"-"+mm+"-"+dd);
												setAssetDetailData((prev)=>{return {...prev,workProgress:100}});
											}
											else 
												$("#workFinishDate").val("0001-01-01");

											return {...prev,workStatus:e.target.value}});
										}} 
									 onBlur={(e)=>_vli(e)} check='mixed' minLen='1' maxLength='64'>
										<option value=""></option>
										<option value="Ongoing">Ongoing</option>
										<option value="Completed">Completed</option>
										
									</select>
									<label>Select work status</label>
								</div>
							</div>
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<select type="text" className="form-select jform-control" id="workProgress" value={assetDetailData.workProgress}  
									placeholder="Enter work progress"
									onChange={e=>{setAssetDetailData((prev)=>{
													return {...prev,workProgress:e.target.value}});
												}} 
									onBlur={(e)=>_vli(e)} check='digit' minLen='1' maxLength='3'
									
									>
										<option value="0">0</option>
										<option value="5">5%</option>
										<option value="10">10%</option>
										<option value="15">15%</option>
										<option value="20">20%</option>
										<option value="25">25%</option>
										<option value="30">30%</option>
										<option value="35">35%</option>
										<option value="40">40%</option>
										<option value="45">45%</option>
										<option value="50">50%</option>
										<option value="55">55%</option>
										<option value="60">60%</option>
										<option value="65">65%</option>
										<option value="70">70%</option>
										<option value="75">75%</option>
										<option value="80">80%</option>
										<option value="85">85%</option>
										<option value="90">90%</option>
										<option value="95">95%</option>
										<option value="100">100%</option>
									</select>
									<label>Select work progress</label>
								</div>
							</div>
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<select type="text" className="form-select jform-control" id="inUse" value={assetInfoData.inUse} 
									 placeholder="Enter In use" 
									 onChange={e=>{setAssetInfoData((prev)=>{
											return {...prev,inUse:e.target.value}});
										}} 
									 onBlur={(e)=>_vli(e)} check='mixed' minLen='1' maxLength='3'>
										<option value="No">No</option>
										<option value="Yes">Yes</option>
										
									</select>
									<label>In use</label>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col'>	
								<div className="form-floating mb-3 mt-3">
									<select type="text" className="form-control jform-control" id="je"
									 value={assetInfoData.je}  placeholder="Enter J.E name" 
									 onChange={e=>{setAssetInfoData((prev)=>{return {...prev,je:e.target.value}});}} onBlur={(e)=>_vli(e)} 
									 check='mixed' minLen='3' maxLength='64'>
										<option value=""></option>
										{engineerList && engineerList.je &&	engineerList.je.map((option,index)=>{
												
												return(
														<option value={option.name}>{option.name}</option>
												);		
											})
										}
									</select>
									<label>Name of J.E</label>
								</div>
							</div>
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<select type="text" className="form-control jform-control" id="ae"
									 value={assetInfoData.ae}  placeholder="Enter A.E name" 
									 onChange={e=>{setAssetInfoData((prev)=>{return {...prev,ae:e.target.value}});}} 
									 onBlur={(e)=>_vli(e)} check='mixed' minLen='3' maxLength='64'>
									 <option value=""></option>
									{engineerList && engineerList.ae &&	engineerList.ae.map((option,index)=>{
											
										 	return(
													<option value={option.name}>{option.name}</option>
											);		
										})
									}
									</select>	
									<label>Name of A.E</label>
								</div>
							</div>
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<select type="text" className="form-control jform-control" 
									id="ee" value={assetInfoData.ee}  
									placeholder="Enter E.E name" 
									onChange={e=>{setAssetInfoData((prev)=>{return {...prev,ee:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='3' maxLength='64'>
									<option value=""></option>
									{engineerList && engineerList.ee &&	engineerList.ee.map((option,index)=>{
											
										 	return(
													<option value={option.name}>{option.name}</option>
											);		
										})
									}
									</select>
									<label>Name of E.E</label>
								</div>
							</div>
						</div>	
						<div className='row'>
						
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<select className="form-select jform-control" 
									id="implementAgency" 
									value={assetInfoData.implementAgency} 
									placeholder="Enter implementAgency" 
									onChange={e=>{
										setAssetInfoData((prev)=>{
											return {...prev,implementAgency:e.target.value}});
										}}
									onBlur={(e)=>_vli(e)} check='mixed' minLen='1'>
									{implAgencyList &&	implAgencyList.map((option,index)=>{
											if(option.implAgencyId===department)
										 	return(
													<option value={option.implAgencyId}>{option.implAgencyName}</option>
											);		
										})
									}	
									</select>
									<label>Implementing Agency</label>
								</div>
							</div>
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<select className="form-select jform-control" id="fundingAgency" value={assetInfoData.fundingAgency} placeholder="Enter funcding agency" onChange={e=>{setAssetInfoData((prev)=>{return {...prev,fundingAgency:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='1' >
									<option value=""></option>
									{
										fundingAgencyList && fundingAgencyList.map((data,index)=>{
											return(
													<option value={data}>{data}</option>
											);
										})
									}
									</select>
									<label>Funding Agency/Scheme</label>
								</div>
							</div>
							<div className='col'>	
								<div className="form-floating mb-3 mt-3">
									<select className="form-select jform-control" id="userAgency" value={assetInfoData.userAgency} placeholder="Enter user agency" onChange={e=>{setAssetInfoData((prev)=>{return {...prev,userAgency:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='1'>
									<option value=""></option>
									{
										userAgencyList.map((option,index)=>{
										 return(
											<option value={option.userAgencyId}>{option.userAgencyName}</option>
										);		
										})
									}	
									</select>
									<label>User Agency</label>
								</div>
							</div>	
						</div>
						<div className='row'>
							<div className='col-4'>
								<div className="form-floating mb-3 mt-3">
									<select type="text" className="form-select jform-control" id="assetType" value={assetInfoData.assetType} placeholder="Enter asset type" onChange={e=>{setAssetInfoData((prev)=>{return {...prev,assetType:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='3'>
									<option value=""></option>
									{
										assetsCategoryList.map((option,index)=>{
										 return(
											<option value={option.catId}>{option.catName}</option>
										);		
										})
									}		
									</select>
									<label>Asset Type</label>
								</div>
							</div>
							<div className='col-8'>		
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="assetName" value={assetInfoData.assetName} placeholder="Enter asset name"  onChange={e=>{setAssetInfoData((prev)=>{return {...prev,assetName:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='3' maxLength='256'/>
									<label>Asset Name</label>
								</div>
							</div>
							
						</div>	
						<div className='row'>
							<div className='col'>		
								<div className="form-floating mb-3 mt-3">
									<textarea rows="4" className="form-control jform-control" id="assetDescription" placeholder="Enter description" onChange={e=>{setAssetInfoData((prev)=>{return {...prev,assetDescription:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='3' maxLength='1000' value={assetInfoData.assetDescription}></textarea>
									<label>Asset Description</label>
								</div>
							</div>
						</div>	
						<div className='row'>
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="address" value={assetInfoData.address}  placeholder="Enter address" onChange={e=>{setAssetInfoData((prev)=>{return {...prev,address:e.target.value}});}} onBlur={(e)=>_vli(e)}  maxLength='64'/>
									<label>Address</label>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col'>		
								<div className="form-floating mb-3 mt-3">
									<select type="text" className="form-select jform-control" id="state" value={assetInfoData.state}  placeholder="Enter state" onChange={e=>{setAssetInfoData((prev)=>{return {...prev,state:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='3' maxLength='64'>
									<option value="Jharkhand">Jharkhand</option>
									</select>
									<label>State</label>
								</div>
							</div>
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="district" value={assetInfoData.district} readOnly  placeholder="Enter district" onChange={e=>{setAssetInfoData((prev)=>{return {...prev,district:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='3' maxLength='64'/>
									<label>District.</label>
								</div>
							</div>
							
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<select className="form-control jform-control" id="block" 
											value={assetInfoData.block}  
											placeholder="Enter pincode" 
											onChange={e=>{setAssetInfoData((prev)=>{
												setPanchayatList(blockList[e.target.value]);
												return {...prev,block:e.target.value}

											});
										}} 
											onBlur={(e)=>_vli(e)} 
											check='mixed' minLen='3' maxLength='32'>
										<option value=""></option>
										{
											blockList && Object.keys(blockList)?.map((data,index)=>{
												return(<option value={data}>{data}</option>);
											})
										}
									</select>	
									<label>Block</label>
								</div>
							</div>
							
						</div>
						<div className='row'>
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
								<select className="form-control jform-control" id="panchayat" 
											value={assetInfoData.panchayat}  
											placeholder="Enter panchayat" 
											onChange={e=>{setAssetInfoData((prev)=>{
												return {...prev,panchayat:e.target.value}
											});
										}} 
											onBlur={(e)=>_vli(e)} 
											check='mixed' minLen='3' maxLength='32'>
										<option value=""></option>
										{
											panchayatList && panchayatList.map((data,index)=>{
												return(<option value={data}>{data}</option>);
											})
										}
									</select><label>Panchayat</label>
								</div>
							</div>
							<div className='col'>	
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="village" value={assetInfoData.village}  placeholder="Enter mother name" onChange={e=>{setAssetInfoData((prev)=>{return {...prev,village:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='3' maxLength='64'/>
									<label>Village</label>
								</div>
							</div>
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="pin" value={assetInfoData.pin}  placeholder="Enter address" onChange={e=>{setAssetInfoData((prev)=>{return {...prev,pin:e.target.value}});}} onBlur={(e)=>_vli(e)} check='digit' minLen='5' maxLength='6'/>
									<label>Pin code</label>
								</div>
							</div>
						</div>	
						<div className='row'>
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="lat" value={assetDetailData.lat}  placeholder="Enter latitude" onChange={e=>{setAssetDetailData((prev)=>{return {...prev,lat:e.target.value}});}} onBlur={(e)=>_vli(e)} check='decimal' minLen='0' maxLength='64'/>
									<label>Latitude</label>
								</div>
							</div>
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="lat" value={assetDetailData.lng}  placeholder="Enter longitude" onChange={e=>{setAssetDetailData((prev)=>{return {...prev,lng:e.target.value}});}} onBlur={(e)=>_vli(e)} check='decimal' minLen='0' maxLength='64'/>
									<label>Longitude</label>
								</div>
							</div>
							<div className='col'>
								<div className="form-floating mb-3 mt-3">
									<select type="text" className="form-select jform-control" id="beneficiary" value={assetInfoData.beneficiary}  placeholder="Enter beneficiary" onChange={e=>{setAssetInfoData((prev)=>{return {...prev,beneficiary:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='3' maxLength='64'>
										<option value=""></option>
										<option value="Individual">Individual</option>
										<option value="Department">Department</option>
										<option value="Public">Public</option>
									</select>
									<label>Type of beneficiary</label>
								</div>
							</div>
						</div>	
					</div>
					<div className='col-md-4 p-4 rounded-2 mt-4' style={{backgroundColor:'#efefef'}}>
						<h5 style={{color:'#80808a',fontWeight:450}}><i className='bi bi-boxes'></i> Contractor</h5>
						<div className='row'>
							<div className='col'>		
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="cregNo" placeholder="Enter registration no" value={contractorInfoData.regNo} onChange={e=>{setContractorInfoData((prev)=>{return {...prev,regNo:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='3' maxLength='64'/>
									<label>Registration/License No</label>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col'>		
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="cname" placeholder="Enter name" value={contractorInfoData.name} onChange={e=>{setContractorInfoData((prev)=>{return {...prev,name:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='3' maxLength='64'/>
									<label>Name</label>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col'>		
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="ccompany" placeholder="Enter company name" value={contractorInfoData.companyName} onChange={e=>{setContractorInfoData((prev)=>{return {...prev,companyName:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='3' maxLength='64'/>
									<label>Company</label>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col'>		
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="ccontactNo" placeholder="Enter contact no" value={contractorInfoData.contactNo} onChange={e=>{setContractorInfoData((prev)=>{return {...prev,contactNo:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='3' maxLength='64'/>
									<label>Contact No</label>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col'>		
								<div className="form-floating mb-3 mt-3">
									<input type="text" className="form-control jform-control" id="caddress" placeholder="Enter address" value={contractorInfoData.address} onChange={e=>{setContractorInfoData((prev)=>{return {...prev,address:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='3' maxLength='64'/>
									<label>Address</label>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col'>
							<div className="form-floating mb-3 mt-3">
								<input type="text" className="form-control jform-control" id="cdistrict" placeholder="Enter district" value={contractorInfoData.district} onChange={e=>{setContractorInfoData((prev)=>{return {...prev,district:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='3' maxLength='64'/>
								<label>District</label>
							</div>
							</div>
							<div className='col'>
							<div className="form-floating mb-3 mt-3">
									<select type="text" className="form-select jform-control" id="cstate" value={contractorInfoData.state}  placeholder="Enter state" onChange={e=>{setContractorInfoData((prev)=>{return {...prev,state:e.target.value}});}} onBlur={(e)=>_vli(e)} check='mixed' minLen='3' maxLength='64'>
									<option value=""></option>
									<option value="Andhra Pradesh">Andhra Pradesh</option>
									<option value="Arunachal Pradesh">Arunachal Pradesh</option>
									<option value="Assam">Assam</option>
									<option value="Bihar">Bihar</option>
									<option value="Chhattisgarh">Chhattisgarh</option>
									<option value="Goa">Goa</option>
									<option value="Gujarat">Gujarat</option>
									<option value="Haryana">Haryana</option>
									<option value="Himachal Pradesh">Himachal Pradesh</option>
									<option value="Jammu and Kashmir">Jammu and Kashmir</option>
									<option value="Jharkhand">Jharkhand</option>
									<option value="Karnataka">Karnataka</option>
									<option value="Kerala">Kerala</option>
									<option value="Madhya Pradesh">Madhya Pradesh</option>
									<option value="Maharashtra">Maharashtra</option>
									<option value="Manipur">Manipur</option>
									<option value="Meghalaya">Meghalaya</option>
									<option value="Mizoram">Mizoram</option>
									<option value="Nagaland">Nagaland</option>
									<option value="Odisha">Odisha</option>
									<option value="Punjab">Punjab</option>
									<option value="Rajasthan">Rajasthan</option>
									<option value="Sikkim">Sikkim</option>
									<option value="Tamil Nadu">Tamil Nadu</option>
									<option value="Telangana">Telangana</option>
									<option value="Tripura">Tripura</option>
									<option value="Uttar Pradesh">Uttar Pradesh</option>
									<option value="Uttarakhand">Uttarakhand</option>
									<option value="West Bengal">West Bengal</option>
									</select>
									<label>State</label>
								</div>	
							</div>
						</div>
					</div>	
				</div>
				<div className='col-md-12 p-4 rounded-2 mt-4' style={{backgroundColor:'#efefef'}}>
				<div className='mt-2'>
					<h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-boxes'></i> Financial Detail</h5>
					<div className='row'>
						<div className='col'>
							<div className="form-floating mb-3 mt-3">
								<input type="text" className="form-control jform-control" id="agrCost" 
								placeholder="Enter university name" value={assetDetailData.agrCost} 
								onChange={e=>{
									
									setAssetDetailData((prev)=>{return {...prev,agrCost:e.target.value}});
									
								}}
								onBlur={(e)=>_vli(e)} check='digit' minLen='2' maxLength='15'/>
								<label>Agreement Cost <RS_LABEL/></label>
							</div>
						</div>
						<div className='col'>
							<div className="form-floating mb-3 mt-3">
								<input type="date" className="form-control jform-control" id="agrDate" 
								placeholder="Enter agreement date"  
								value={assetDetailData.agrDate}
								onChange={e=>{
									setAssetDetailData((prev)=>{return {...prev,agrDate:e.target.value}});
									}} 
								onBlur={(e)=>_vli(e)} check='yyyy-mm-dd' minLen='10' maxLength='15'/>
								<label>Agreement Date </label>
							</div>
						</div>
						<div className='col'></div>
					</div>	
					<div className='row'>
						<div className='col'>	
							<div className="form-floating mb-3 mt-3">
								<input type="text" className="form-control jform-control" 
								id="estCost" placeholder="Enter estimated cost" 
								value={assetDetailData.estCost} 
								onChange={(e)=>{
									 
									 setAssetDetailData((prev)=>{return {...prev,estCost:e.target.value}});
									}} onBlur={(e)=>_vli(e)} check='digit' minLen='2' maxLength='15'/>
								<label>Estimated Cost <RS_LABEL/></label> 
							</div>
						</div>
						<div className='col'>	
							<div className="form-floating mb-3 mt-3">
								<input type="date" className="form-control jform-control" 
								id="estWorkStartDate" 
								placeholder="Enter estimated work start date" 
								
								autocomplete="off"
								value={assetDetailData.estWorkStartDate}
								onChange={e=>{
									setAssetDetailData((prev)=>{return {...prev,estWorkStartDate:e.target.value}});
									}} 
								onBlur={(e)=>_vli(e)} check='yyyy-mm-dd' minLen='10' maxLength='10'/>
								<label>Estimated Work Start Date </label>
							</div>
						</div>
						<div className='col'>	
							<div className="form-floating mb-3 mt-3">
								<input type="number" className="form-control jform-control" 
								id="estWorkCompleteByDays" 
								placeholder="Enter address" 
								value={assetDetailData.estWorkCompleteByDays} 
								onChange={e=>{setAssetDetailData((prev)=>{return {...prev,estWorkCompleteByDays:e.target.value}});}} onBlur={(e)=>_vli(e)} check='digit' minLen='1' maxLength='5'/>
								<label>Estimated Work Finish by Days</label>
							</div>
						</div>	
					</div>
					
					
					<div className='row'>
						<div className='col'>
							<div className="form-floating mb-3 mt-3">
								<input type="date" className="form-control jform-control" id="workStartDate" 
								placeholder="Enter work start date" 
								value={assetDetailData.workStartDate}
								onChange={e=>{
									setAssetDetailData((prev)=>{return {...prev,workStartDate:e.target.value}});
									}}
								 onBlur={(e)=>_vli(e)} check='yyyy-mm-dd' minLen='10' maxLength='10'/>
								<label>Work Start Date </label>
							</div>
						</div>
						<div className='col'>
							<div className="form-floating mb-3 mt-3">
								<input type="date" className="form-control " id="workFinishDate"

								placeholder="Enter work finish date" 
								 disabled={assetDetailData.workStatus==="Ongoing"? true:false} 
								 value={assetDetailData.workFinishDate}
								 onChange={e=>{
										setAssetDetailData((prev)=>{return {...prev,workFinishDate:e.target.value}});
									 }}
								onBlur={(e)=>_vli(e)} 
								check='mixed' minLen='10' maxLength='10'/>
								<label>Work Finish Date </label>
							</div>
						</div>
						<div className='col'>
							<div className="form-floating mb-3 mt-3">
								<input type="number" className="form-control jform-control" id="maintenanceDays"

								placeholder="Enter work finish date" value={assetDetailData.maintenanceDays}  
								onChange={e=>{
									setAssetDetailData((prev)=>{return {...prev,maintenanceDays:e.target.value}});	
								}}
								onBlur={(e)=>_vli(e)} 
								check='digit' minLen='1' maxLength='7'/>
								<label>Maintenance Period in days</label>
							</div>
						</div>
					</div>
				</div>
				</div>
				<div className='row'>
					<div className='col'>	
						<div className="text-end mb-3 mt-3">
						<button className='btn btn-secondary px-4 py-2 me-4'
							onClick={(e)=>{
								clearForm();
							}}
							>Clear Form</button>
							<button className='btn btn-secondary px-4 py-2'
							onClick={(e)=>{
								
								_vlai();
								let redBoxes=$(".form-control-error");
								if(redBoxes && redBoxes.length===0)
									props.modalObject.yesNo("Sure you want to submit record?",submitForm);
								else props.modalObject.ok("kindly fill all required details");

							}}
							>Submit Form</button>
						</div>
					</div>
				</div>
				
				
	
	</>

);
};
export default JComponent;